import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";;
import { Router } from "@angular/router";
import { Observable } from "rxjs/Observable";
import { ElearningCourse, ElearningModule, ElearningResult, Pagination } from "../../../../models";
import { ELearningService } from "./elearning.service";
import { USERHOMECONSTANTS } from "../../userHome.constants";

const _ = require("underscore");

@Component({
    selector: "elearning-component",
    template: require("./elearning.component.html"),
    styles: [require("./elearning.component.less").toString()],
    providers: [ELearningService]
})

export class ElearningComponent implements OnInit {
    @Input() elearningCourses: Observable<ElearningCourse[]>;
    @Input() elearningModules: Observable<ElearningModule[]>;
    @Input() elearningResults: Observable<ElearningResult[]>;
    @Output() refreshCourses: EventEmitter<any> = new EventEmitter();
    @Output() refreshModules: EventEmitter<any> = new EventEmitter();
    @Output() refreshResults: EventEmitter<any> = new EventEmitter();
    errorMessage: string;
    errors: Error[];
    isProcessing: boolean;
    selectedCategoryId: number;
    selectedCourseId: number;
    resultsComponent = {
        sortColumnIndex: 1,
        courseId: 0,
        sortOrder: USERHOMECONSTANTS.sorting.descOrderString,
        sortColumn: "Firstname",
        pagination: new Pagination(),
        items: new Array<ElearningResult>()
    };
    constructor(private cecRouter: Router, private elearningService: ELearningService) {
        this.resultsComponent.pagination = {
            totalItems: 0,
            currentPage: USERHOMECONSTANTS.pagination.currentPage,
            itemsPerPage: USERHOMECONSTANTS.pagination.itemsPerPage,
            maxSize: USERHOMECONSTANTS.pagination.maxSize
        };
    }

    // region : event handlers

    public ngOnInit(): void {

        this.errorMessage = "";
        this.errors = [];

        this.elearningService
            .GetElearningCourses()
            .subscribe(
            response => {
                this.refreshCourses.emit(<ElearningCourse[]>response);
            },
            (error) => {
                let paersedErrors = JSON.parse(error._body);
                if (paersedErrors) {
                    this.errorMessage = paersedErrors.message;
                }
            });
    }

    public LoadModules(cateogryId) {
        this.resultsComponent.pagination.totalItems = 0;
        this.elearningService
            .GetElearningModules(cateogryId)
            .subscribe(
            response => {
                this.refreshModules.emit(<ElearningModule[]>response);
            },
            (error) => {
                let paersedErrors = JSON.parse(error._body);
                if (paersedErrors) {
                    this.errorMessage = paersedErrors.message;
                }
            });
    }

    public LoadModuleResults(courseId) {
        this.resultsComponent.courseId = courseId;
        this.GetModuleResults();
    }

    public PageChanged(currentPageObject) {
        this.resultsComponent.pagination.currentPage = currentPageObject.page;
        this.GetModuleResults();
    }

    private GetModuleResults() {
        this.elearningService
            .GetElearningCourseResults(this.resultsComponent.courseId, this.resultsComponent.pagination, this.resultsComponent.sortOrder, this.resultsComponent.sortColumn)
            .map(response => response.json())
            .subscribe(
            response => {
                this.refreshResults.emit(<ElearningResult[]>response.result);
                this.resultsComponent.pagination.totalItems = response.count; // get from the response 
            },
            (error) => {
                let paersedErrors = JSON.parse(error._body);
                if (paersedErrors) {
                    this.errorMessage = paersedErrors.message;
                    this.resultsComponent.items = [];
                }
            });
    }

    public SortList(columnIndex: number) {
        if (columnIndex === this.resultsComponent.sortColumnIndex) {
            if (this.resultsComponent.sortOrder === USERHOMECONSTANTS.sorting.ascOrderString) {
                this.resultsComponent.sortOrder = USERHOMECONSTANTS.sorting.descOrderString;
            } else {
                this.resultsComponent.sortOrder = USERHOMECONSTANTS.sorting.ascOrderString;
            }
        } else {
            this.resultsComponent.sortOrder = USERHOMECONSTANTS.sorting.ascOrderString;
            switch (columnIndex) {

                case 1:
                    this.resultsComponent.sortColumn = "Firstname";
                    break;
                case 2:
                    this.resultsComponent.sortColumn = "Lastname";
                    break;
                case 3:
                    this.resultsComponent.sortColumn = "Category";
                    break;
                case 4:
                    this.resultsComponent.sortColumn = "CourseFullName";
                    break;
                     case 5:
                     this.resultsComponent.sortColumn = "GradeFinal";
                    break;
                     case 6:
                    this.resultsComponent.sortColumn = "Email";
                    break;
                     case 7:
                    this.resultsComponent.sortColumn = "OrganisationName";
                    break;
                default:
                    this.resultsComponent.sortColumn = "DioceseName";
            }
        }

        this.resultsComponent.sortColumnIndex = columnIndex;
        this.GetModuleResults();
    }

    public SortIconClass(columnIndex): string {
        if (columnIndex === this.resultsComponent.sortColumnIndex) {
            if (this.resultsComponent.sortOrder === USERHOMECONSTANTS.sorting.ascOrderString) {
                return USERHOMECONSTANTS.sorting.ascIconClass;
            } else {
                return USERHOMECONSTANTS.sorting.descIconClass;
            }
        } else {
            return "";
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/userHome/reports/elearning/elearning.component.ts